import React, { useRef, useEffect } from 'react';
import { connect } from "react-redux";
import { Route, Switch } from 'react-router-dom';

import AuthUserProvider from './login/AuthUserContext';

import PrivateRoute from './login/PrivateRoute';
import WelcomePage from './welcome/WelcomePage';
import LoginPage from './login/LoginPageContainer';
import SignupPage from './login/SignupPageContainer';

import './css/App.css';

const App = ({
  dispatch,
  loginResult,
  pathname,
  processing,
  searchPageHeight,
  navBarVertHeight,
  navBarWidth,
  navBarHeight,
  navBarActive
}) => {
  const ref = useRef(null);

  if (ref.current !== null && processing === 1)
    ref.current.style.cursor = 'wait';
  else if (ref.current !== null)
    ref.current.style.cursor = 'default';

  return (
    <AuthUserProvider>
      <Switch>
        <Route exact path="/" component={WelcomePage} />
        <Route path="/welcome" component={WelcomePage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/signup" component={SignupPage} />
        <PrivateRoute
          exact path={pathname}
          pathname={pathname}
          processing={processing}
          searchPageHeight={searchPageHeight}
          navBarVertHeight={navBarVertHeight}
          navBarWidth={navBarWidth}
          navBarHeight={navBarHeight}
          navBarActive={navBarActive}
        />
      </Switch>
    </AuthUserProvider>
  );
}

const mapStateToProps = state => ({
  loginResult: state.login.loginResult,
  pathname: state.router.location.pathname,
  processing: state.reserve.processing,
  searchPageHeight: state.search.searchPageHeight,
  navBarVertHeight: state.reserve.navBarVertHeight,
  navBarWidth: state.navigation.navBarWidth,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(App);
